module.exports = __webpack_public_path__ + "static/media/sub-10.07c10d09.jpg";